import { BlogPost, Poll, Stamp, User, UserLocation,  } from "./global-components/src/types";
import { LinkPreviewData } from "./utils/social-links";
export type { BlogPost };

export interface Post {
    id: number;
    id_user: number;
    deleted_at?: Date;
    deleted_reason?: string;
    reaction_summary?: string[] | string;
    user_reaction?: string | null;
    is_hidden?: boolean;
    hidden_reason?: string;
    image_moderation_status?: 'not_required' | 'pending' | 'processing' | 'allowed' | 'review' | 'removed';
    pending_approval?: boolean;
    type: string;
    original_post_id: number;
    group_id: number | null;
    total_likes: number;
    total_shares: number;
    total_comments: number;
    total_saved?: number;
    text?: string;
    liked: boolean;
    user_is_blocked: boolean;
    user_is_muted?: boolean;
    tags?: string[] | null;
    created_at: string;
    updated_at: string;
    content: string;
    user: User;
    images: ImagePost[]
    original_post: Post;
    poll: Poll;
    poem_id?: number;
    poem_title?: string;
    gif_url?: string | null;
    group: Group
    ads?: Ads
    reported?: boolean;
    is_following?: boolean;
    is_saved?: boolean;
    has_is_following?: boolean;
    pinned_comment_ids?: number[];
    link_preview?: LinkPreviewData | null;
}

export interface Ads {
    id: number;
    id_post: number;
    name: string;
    status: "pendente" | "ativo" | "validando_conteudo" | "online" | "off" | "reprovado"
    post: Post;
    button_text: string;
    button_url: string;
    views?: number | null;
    expected_views?: number | null;
    price: string | number | null;
}

export interface AdsPreview {
    user: User | null;
    text: string;
    buttonText: string;
    buttonUrl: string;
    price: string | number | null;
    content: string;
    images?: ImagePost[]
}

export interface Pix {
    chave: string;
    pixCopiaECola: string;
    revisao: number;
    status: "ATIVA" | "pago";
    txid: string;
    valor: { original: string };
}

export interface Payment {
    status: "ATIVA" | "pago" | "pendente";
    pixCopiaECola: string;
    txid: string;
    valor: string;
    qrcode:  string;
}

export interface QrCode {
    imagemQrcode: string;
    linkVisualizacao: string;
    qrcode: string;
}

export interface Community{
    id: number;
    img: string;
    description: string;
    color: string;
    can_edit: boolean;
    can_manage_members: boolean;
    is_admin: boolean;
    can_delete: boolean;
    name: string;
    total_members: number;
    total_posts: number;
    chat_id?: number | null;
    post_approval?: boolean;
    is_private?: boolean;
    pending_join?: boolean;
}

export interface Comment{
    id: number;
    id_comment: number;
    responses: any;
    total_responses: number;
    total_likes: number;
    is_liked: boolean;
    can_edit: boolean;
    can_delete: boolean;
    can_pin?: boolean;
    is_pinned?: boolean;
    text: string;
    textFormatted: string;
    user: User;
    original_comment: Comment;
    created_at: Date;
    gif_url?: string;
    is_hidden?: boolean;
    hidden_reason?: string;
    idNotSend?: string;
    images?: ImageComment[]
}

export enum StatusString {
    error = "error",
    success = "success",
    loading = "loading",
} 

// export interface User {
//     sexo: string;
//     session_id: string;
//     readbook_user_id?: number | null;
//     created_at: Date;
//     next_payment: Date;
//     birth_date: Date;
//     phone: string;
//     email: string;
//     can_ban_user: any;
//     pinned_post_id: number;
//     verified_profile: number;
//     privacy: number;
//     is_following: boolean;
//     is_followed: boolean;
//     can_edit_permissions: boolean;
//     can_see_location?: boolean;
//     location?: UserLocation;
//     is_blocked: boolean;
//     permissions: string;
//     site: string;
//     token: string;
//     is_banned: Date | null;
//     biography: string;
//     is_visible: boolean;
//     can_remove_photo: boolean;
//     can_send_warn: boolean;
//     can_delete_account: boolean;
//     email_verified_at: Date;
//     position: number;
//     user_id: any;
//     id: number;
//     name: string;
//     user_name: string;
//     img_account: string;
//     total_posts: number;
//     total_followers: number;
//     total_following: number;
//     total_comments: number;
//     reported?: boolean;
//     stamps: Stamp[]
//     active_frame?: ActiveFrame
// }

export interface ActiveFrame{
    image_path: string
}

// export interface Book {
//     id_livro: number
//     img_livro: string
//     title: string
// }

export interface Group {
    id: number;
    img: any;
    name: string;
    description: string;
}

export interface ImagePost {
    id: number;
    path: string;
    type: number;
    id_post: number;
    file?: File,
}
export interface ImageComment {
    id: number;
    isTemp?: boolean;
    path: string;
    type: number;
    id_comment: number;
    file?: File,
}

export interface Ban{
    id: number;
    blocked_until: Date | null;
    created_at: Date;
    user_id: number;
    reason?: string | null;
    user: User;
}

export interface Notification{
    id: number;
    opened: boolean;
    text: string;
    text_secondary?: string;
    link1: string;
    img_notification: string;
    title: string;
    type: string;
    created_at: Date;
} 

export interface Chat{
    last_message: MessageChat | null;
    last_message_read?: number | null;
    chat_id: number;
    total_posts: number;
    total_comments: number;
    total_followers: number;
    total_following: number;
    verified_profile: number;
    img_account: string;
    biography: string;
    site: string;
    name: string;
    user_name: string;
    nickname?: string | null;
    original_name?: string | null;
    user_id: string;
    is_online?: boolean;
    is_group?: boolean;
    group_name?: string;
    group_img?: string | null;
    description?: string | null;
    only_admin_post?: boolean;
    is_admin?: boolean;
    is_creator?: boolean;
    is_community_chat?: boolean;
    community_id?: number | null;
    is_muted?: boolean;
    my_status?: 'principal' | 'pending' | 'general' | 'rejected';
    other_status?: 'principal' | 'pending' | 'general' | 'rejected';
    direct_request_state?: 'pending' | 'accepted' | 'rejected';
    direct_request_sender_id?: number | null;
    can_manage_request?: boolean;
    created_at?: string;
}

export interface ChatMessageReaction {
    id?: number;
    chat_message_id: number;
    user_id: number;
    emoji: string;
    user?: User;
    created_at?: string;
}

export interface PinnedMessage {
    id: number;
    chat_id: number;
    chat_message_id: number;
    pinned_by: number;
    created_at: string;
    message: MessageChat | null;
    pinnedByUser?: { id: number; name: string; user_name: string } | null;
}

export interface FavoriteMessage {
    id: number;
    message_id: number;
    chat_id: number;
    created_at: string;
    message: MessageChat | null;
    chat: {
        is_group: boolean;
        group_name?: string;
        group_img?: string | null;
        user?: { id: number; name: string; user_name: string; img_account: string } | null;
    } | null;
}

export interface MessageChat{
    id: number;
    user?: User;
    chat_id: number;
    gif_url?: string;
    created_at: string;
    file_path?: string;
    file_type?: string;
    file_name?: string;
    text: string;
    message_type?: "text" | "system";
    system_key?: string | null;
    system_params?: Record<string, string> | null;
    user_id: number;
    isTyping?: boolean;
    idNotSend?: boolean;
    errorSend?: boolean;
    reply_to_id?: number | null;
    reply_to?: MessageChat | null;
    reactions?: ChatMessageReaction[];
    is_view_once?: boolean;
    is_read?: boolean;
    read_at?: string | null;
    read_by_count?: number;
    read_by_total?: number;
    view_once_opened_at?: string | null;
    is_pinned?: boolean;
    is_favorited?: boolean;
}

export interface Session{
    id: number;
    browser: string;
    platform: string;
    updated_at: string;
    last_activity: string;
    user_agent: string;
    ip_address: string;
    country: string;
    city: string;
    region_name: string;
    token: string;
}


export interface StoryUser {
  id: number;
  name: string;
  avatar: string;
}

export type MediaType = "image" | "video";

export interface Story {
  id: number;
  id_user: number;
  media_url: string;
  media_type: MediaType;
  created_at: string;
  expires_at: string;
  has_viewed?: boolean;
  is_best_friends?: boolean;
  reactions: [];
  user: User;
}

export interface UserStories {
  user: User;
  stories: Story[];
}

export interface Instant {
  id: number;
  id_user: number;
  media_url: string;
  created_at: string;
  expires_at: string;
  user_reaction?: string | null;
  user: User;
}

export interface UserStats {
  total_posts: number;
  total_comments: number;
  total_followers: number;
  total_following: number;
  total_communities: number;
  total_likes: number;
  total_reposts: number;
  monthly_posts: { month: string; posts: number }[];
}

export interface TopUser {
  id: number;
  name: string;
  username?: string;
  user_name?: string;
  followers_count: number;
}

export interface TopPost {
  id: number;
  title: string;
  slug: string;
}

export interface RetrospectiveNetworkPost {
  id: number;
  title?: string | null;
  slug?: string;
  user?: { id: number; name: string; user_name?: string } | null;
  likes_count?: number;
  comments_count?: number;
  reposts_count?: number;
}

export interface RetrospectiveData {
  user: UserStats;
  global: {
    total_users: number;
    total_posts: number;
    total_comments: number;
    perfil_mais_seguido: TopUser | null;
    post_mais_curtido: RetrospectiveNetworkPost | null;
    post_mais_comentado: RetrospectiveNetworkPost | null;
    post_mais_compartilhado: RetrospectiveNetworkPost | null;
  };
  year: number;
  share_url?: string;
}

export interface Frame {
    id: number;
    name: string;
    image_path: string;
    is_active: boolean;
    key: string;
    is_paid: boolean;
    price: number | null;
    expires_at?: string;
    is_active_for_user?: boolean;
    owned?: boolean;
    can_redeem?: boolean;
    can_buy?: boolean;
    is_expired?: boolean;
    is_owned?: boolean;
    can_activate?: boolean;
};

export interface FrameCategory{
    id: number;
    name: string;
    frames: Frame[];
}

export interface ReelComment {
    id: number;
    reel_id: number;
    text: string;
    gif_url?: string | null;
    images?: Array<{ id: number | string; path: string; type: number | string }>;
    user: User;
    parent_id: number | null;
    replies?: ReelComment[];
    created_at: string;
    can_delete?: boolean;
    can_edit?: boolean;
    can_pin?: boolean;
    is_pinned?: boolean;
}

export interface Reel {
    id: number;
    id_user: number;
    video_path: string;
    thumbnail_path: string | null;
    bucket: "reflexo" | "pacoca";
    caption: string | null;
    audio_title: string | null;
    tags?: string[] | null;
    total_likes: number;
    total_comments: number;
    total_views: number;
    total_shares: number;
    liked: 0 | 1 | boolean;
    saved: 0 | 1 | boolean;
    reported: 0 | 1 | boolean;
    is_hidden: boolean;
    user: User;
    created_at: string;
}
